import { Storybook } from "@tento-ui/ui/storybook";
import { TurnThought } from "./thought";

const REASONING =
  "The projection arrives with null collections on a racing session, so the crash is in the renderer rather than the parser. Normalizing once at the boundary is better than guarding every call site — there are eleven of them and a twelfth will be written next week.";

export class TurnThoughtStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · thought";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Collapsed — the default",
        render: () => TurnThought.makeWith({ text: REASONING }),
      },
      {
        title: "Expanded",
        render: () =>
          TurnThought.makeWith({ text: REASONING, expanded: true }),
      },
      {
        title: "Caller-supplied summary",
        render: () =>
          TurnThought.makeWith({
            text: REASONING,
            summary: "Thought for 4s about the null projection",
          }),
      },
    ];
  }
}
